exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  color: gray; }\n\n/*label {\r\n    color: rgb(255, 1, 1);\r\n}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/Informes/Informes.component.scss
// module id = ../../../../../src/app/views/Informes/Informes.component.scss
// module chunks = main